import { withTheme } from "@mui/styles";
import styled from "styled-components";

import { Flexbox } from "ui-library/layouts/Flexbox/Flexbox";

export const StyledInfoText = withTheme(styled(Flexbox)``);
